import { useEffect, useState } from 'react';
import { AuthUser } from '../types/auth';
import { jwtDecode } from 'jwt-decode';

const useProfile = () => {
    const accessToken: any = localStorage.getItem('access_token');
    const userProfileSession: any = accessToken ? jwtDecode(accessToken) : null;
    const [loading, setLoading] = useState(!userProfileSession);
    const [userProfile, setUserProfile] = useState<AuthUser | null>(userProfileSession);

    useEffect(() => {
        const accessToken: any = localStorage.getItem('access_token');
        const userProfileSession: any = accessToken ? jwtDecode(accessToken) : null;
        setUserProfile(userProfileSession);
        setLoading(!userProfileSession);
    }, []);

    return { userProfile, loading };
};

export { useProfile };